// Components==============
import indexActivity from 'actions/activity/index';
import indexTrainingSubscription from 'actions/training/subscription/index';
import indexTraining from 'actions/training/training/index';
import indexFeedback from 'actions/feedback/index';
import showPortfolio from 'actions/portfolio/show';
import indexProject from 'actions/project/index';
import indexTheme from 'actions/theme/index';
import Container from 'components/UI/Container/Container';
import EvidenceCard from 'components/UI/EvidenceCard/EvidenceCard';
import Spinner from 'components/UI/Spinner/Spinner';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import './PublicPortfolio.module.scss';
import TopNav from './TopNav/TopNav';
import PortfolioText from '../MyPortfolios/components/PortfolioText/PortfolioText';
// =========================

export default function MyPortfolios() {
  const dispatch = useReduxAction();

  const { shareCode } = useParams() as { shareCode: string };

  const userId = useRedux((state) => state.authentication?.user?.id);

  useEffect(() => {
    dispatch(showPortfolio(shareCode));
    if (userId) {
      dispatch(indexTraining());
      dispatch(indexTrainingSubscription({}));
      dispatch(indexTheme());
      dispatch(indexFeedback());
      dispatch(indexProject());
      dispatch(indexActivity());
    }
  }, []);

  const portfolio = useRedux((state) =>
    state.portfolio?.entities.allIds
      .map((id) => state.portfolio?.entities.byId[id])
      .find((p) => p?.share_code === shareCode)
  );

  const loading = useRedux((state) => state.portfolio?.loading);

  const loadingWithUser = useRedux(
    (state) =>
      state.portfolio?.loading ||
      state.theme?.loading ||
      state.feedback?.loading ||
      state.project?.loading ||
      state.activity?.loading ||
      state.training?.loading ||
      state.trainingSubscription?.loading
  );

  const evidenceEntities = useRedux((state) =>
    portfolio?.content?.map((id) => state.evidence?.entities.byId?.[id])
  );

  return (
    <>
      <TopNav user={portfolio?.author} />
      <Container maxWidth={1280}>
        <div styleName="outer-wrapper">
          <h2>
            {portfolio?.name}{' '}
            <Spinner loading={userId ? loadingWithUser : loading} />
          </h2>
          <div styleName={`wrapper ${portfolio?.layout}`}>
            {evidenceEntities?.map(
              (evidence) =>
                !!evidence && (
                  <div key={evidence?.id} styleName="grid-item">
                    {evidence.type === 'portfolio' ? (
                      <PortfolioText evidence={evidence} />
                    ) : (
                      <EvidenceCard
                        evidence={evidence}
                        height="100%"
                        disableComments={portfolio?.visibility === 'private'}
                        disableMessageBar
                      />
                    )}
                  </div>
                )
            )}
          </div>
        </div>
      </Container>
    </>
  );
}
